import { render, staticRenderFns } from "./LoaLevelDescriptions.vue?vue&type=template&id=ac7888a6&"
import script from "./LoaLevelDescriptions.vue?vue&type=script&lang=js&"
export * from "./LoaLevelDescriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac7888a6')) {
      api.createRecord('ac7888a6', component.options)
    } else {
      api.reload('ac7888a6', component.options)
    }
    module.hot.accept("./LoaLevelDescriptions.vue?vue&type=template&id=ac7888a6&", function () {
      api.rerender('ac7888a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LoaLevelDescriptions.vue"
export default component.exports